import React from "react";

import "./TermsandConditions.css";

const TermsandConditions = () => {
  return (
    <>
      <div className="termsContainer">
        <h2>USLOVI KORIŠTENJA I KUPOVINE</h2>

        <div className="termsContent">
          <p>
            <strong>Datum posljednje izmjene:</strong> 11.08.2026.
          </p>

          <section>
            <h3>1. Podaci o trgovcu</h3>

            <p>
              Internetsku prodavnicu Optika Alpha Focus, dostupnu na adresi{" "}
              <a
                href="https://optika-alphafocus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                optika-alphafocus.com
              </a>
              , vodi:
            </p>

            <p>
              <strong>
                TR ALPHA FOCUS, vl. Selimović Vedad, Srebrenik
              </strong>
              <br />
              Ulica 1. Marta
              <br />
              75350 Srebrenik
              <br />
              Bosna i Hercegovina
              <br />
              ID broj: 4311663900005
              <br />
              Telefon:{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>
              <br />
              E-mail:{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
            </p>

            <p>
              Adresa sjedišta i prodajnog mjesta je ista. U nastavku teksta
              koristimo izraz „Trgovac“.
            </p>

            <p>
              Kupac je svaka fizička ili pravna osoba koja putem webshopa
              naruči proizvod.
            </p>
          </section>

          <section>
            <h3>2. Primjena uslova</h3>

            <p>
              Ovi uslovi uređuju korištenje webshopa, naručivanje, plaćanje,
              dostavu, odustanak od kupovine, zamjenu proizvoda,
              reklamacije i druga pitanja povezana s kupovinom putem webshopa.
            </p>

            <p>
              Kupac je dužan pročitati ove uslove prije potvrđivanja narudžbe.
              Potvrđivanjem odgovarajućeg polja na stranici za završetak
              kupovine kupac potvrđuje da je pročitao i prihvatio Uslove
              korištenja i kupovine te Politiku privatnosti.
            </p>

            <p>
              Ako se kupac ne slaže s ovim uslovima, ne treba koristiti
              webshop niti izvršiti narudžbu.
            </p>
          </section>

          <section>
            <h3>3. Informacije o proizvodima</h3>

            <p>
              Trgovac nastoji osigurati da nazivi, opisi, karakteristike,
              fotografije, dostupnost i cijene proizvoda budu tačni i ažurni.
            </p>

            <p>
              Fotografije proizvoda su informativne. Moguće su manje razlike u
              boji ili prikazu zbog osvjetljenja, postavki ekrana, fotografije
              ili proizvodnih varijacija.
            </p>

            <p>
              Takve manje razlike ne utiču na pravo kupca da reklamira proizvod
              koji je oštećen, neispravan, pogrešno isporučen ili značajno ne
              odgovara opisu na webshopu.
            </p>

            <p>
              Dostupnost proizvoda prikazana na webshopu može se promijeniti.
              Ako naručeni proizvod nije dostupan, Trgovac će kontaktirati
              kupca i ponuditi zamjenu, čekanje dostupnosti ili otkazivanje
              narudžbe.
            </p>
          </section>

          <section>
            <h3>4. Cijene</h3>

            <p>
              Sve cijene proizvoda prikazane su u konvertibilnim markama
              (BAM/KM).
            </p>

            <p>
              Prije potvrđivanja narudžbe kupcu se prikazuju:
            </p>

            <ul>
              <li>naziv svakog odabranog proizvoda;</li>
              <li>količina proizvoda;</li>
              <li>pojedinačna cijena proizvoda;</li>
              <li>ukupna vrijednost proizvoda;</li>
              <li>trošak dostave;</li>
              <li>eventualni popust;</li>
              <li>konačan iznos za plaćanje.</li>
            </ul>

            <p>
              Trošak dostave iznosi <strong>12,00 KM</strong>.
            </p>

            <p>
              Trgovac može promijeniti cijene proizvoda, ali promjena cijene ne
              utiče na narudžbe koje su već potvrđene.
            </p>

            <p>
              Ako je zbog tehničke ili druge očigledne greške prikazana
              netačna cijena, Trgovac će obavijestiti kupca prije slanja
              proizvoda. Kupac može prihvatiti ispravnu cijenu ili otkazati
              narudžbu.
            </p>
          </section>

          <section>
            <h3>5. Postupak naručivanja</h3>

            <p>
              Kupac bira željeni proizvod, dodaje ga u korpu, odabire količinu,
              unosi podatke za dostavu, bira način plaćanja i pregleda konačan
              iznos narudžbe.
            </p>

            <p>
              Narudžba se šalje klikom na dugme „Izvrši narudžbu“. Prije slanja
              narudžbe kupac ima mogućnost provjeriti unesene podatke,
              odabrane proizvode, količine, cijene i trošak dostave.
            </p>

            <p>
              Kod kartičnog plaćanja kupac se nakon slanja narudžbe
              preusmjerava u sigurno Monri WebPay okruženje radi unosa
              kartičnih podataka i završetka plaćanja.
            </p>

            <p>
              Narudžba je zaprimljena kada webshop prikaže potvrdu o
              zaprimanju narudžbe. Kod kartičnog plaćanja narudžba se smatra
              plaćenom tek nakon uspješne potvrde kartične transakcije.
            </p>

            <p>
              Kupac je odgovoran za tačnost i potpunost podataka koje unese
              prilikom naručivanja.
            </p>
          </section>

          <section>
            <h3>6. Načini plaćanja</h3>

            <p>Na webshopu su dostupni sljedeći načini plaćanja:</p>

            <ul>
              <li>plaćanje pouzećem;</li>
              <li>
                kartično plaćanje karticama označenim na stranici za završetak
                kupovine.
              </li>
            </ul>

            <h4>Plaćanje pouzećem</h4>

            <p>
              Kod plaćanja pouzećem kupac plaća narudžbu prilikom preuzimanja
              pošiljke, u skladu s mogućnostima dostavne službe.
            </p>

            <h4>Kartično plaćanje</h4>

            <p>
              Kartično plaćanje obrađuje Monri Payments putem sistema Monri
              WebPay. Kartični podaci unose se u sigurnom Monri okruženju i
              nisu dostupni Trgovcu.
            </p>

            <p>
              Kod kartičnog plaćanja narudžba se smatra plaćenom tek kada
              Trgovac primi potvrdu da je transakcija uspješno odobrena.
            </p>

            <p>
              Ako banka ili pružalac platne usluge odbiju transakciju,
              narudžba neće biti označena kao plaćena. Za dodatne informacije o
              razlogu odbijanja kupac se može obratiti banci koja je izdala
              karticu.
            </p>
          </section>

          <section>
            <h3>7. Sigurnost kartičnog plaćanja</h3>

            <p>
              Prijenos podataka tokom kartičnog plaćanja zaštićen je TLS/SSL
              enkripcijom. Monri Payments je pružalac platnih usluga
              certificiran prema PCI DSS Level 1 standardu.
            </p>

            <p>
              Radi dodatne zaštite kartične transakcije može se koristiti 3D
              Secure sigurnosna potvrda putem banke koja je izdala karticu.
            </p>

            <p>
              Trgovac nema pristup punom broju kartice, datumu isteka kartice
              niti CVV sigurnosnom kodu i ne pohranjuje te podatke.
            </p>

            <p>
              Više informacija o pružaocu platnih usluga dostupno je na{" "}
              <a
                href="https://monri.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                službenoj stranici Monri Payments
              </a>
              .
            </p>
          </section>

          <section>
            <h3>8. Dostava</h3>

            <p>
              Dostava se vrši putem X express kurirske službe na adresu
              koju kupac navede prilikom naručivanja.
            </p>

            <p>
              Očekivani rok dostave je{" "}
              <strong>od 24 sata do 5 radnih dana</strong> od potvrde narudžbe,
              odnosno od potvrde uspješnog kartičnog plaćanja.
            </p>

            <p>
              Rok dostave može biti duži za proizvode koji se izrađuju ili
              prilagođavaju prema zahtjevu kupca, tokom praznika, u slučaju
              dostave na udaljena područja ili zbog okolnosti izvan razumne
              kontrole Trgovca.
            </p>

            <p>
              Ako nastane značajno kašnjenje ili naručeni proizvod nije moguće
              dostaviti, Trgovac će o tome obavijestiti kupca putem dostavljenih
              kontakt podataka.
            </p>

            <p>
              Kupac je dužan navesti potpunu i tačnu adresu dostave. Trgovac ne
              odgovara za kašnjenje ili nemogućnost dostave nastalu zbog
              netačne ili nepotpune adrese koju je unio kupac.
            </p>

            <p>
              Kupac treba prilikom preuzimanja pregledati vanjsko stanje
              paketa. Vidljivo oštećenje paketa potrebno je odmah prijaviti
              dostavljaču i Trgovcu.
            </p>
          </section>

          <section>
            <h3>9. Odustanak od kupovine</h3>

            <p>
              Kupac ima pravo odustati od ugovora sklopljenog na daljinu u roku
              od <strong>15 dana</strong> od prijema proizvoda, pod uslovima i
              uz izuzetke predviđene važećim propisima o zaštiti potrošača.
            </p>

            <p>
              Zahtjev za odustanak kupac može poslati na{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
              . U zahtjevu je potrebno navesti:
            </p>

            <ul>
              <li>ime i prezime kupca;</li>
              <li>broj narudžbe;</li>
              <li>proizvod koji se vraća;</li>
              <li>datum prijema proizvoda;</li>
              <li>kontakt podatke kupca.</li>
            </ul>

            <p>
              Nakon prijema zahtjeva, Trgovac će kupcu dostaviti upute za
              povrat proizvoda.
            </p>

            <p>
              Proizvod treba vratiti bez nepotrebnog odlaganja, uredno
              zapakovan, sa pripadajućom opremom, deklaracijama i
              dokumentacijom.
            </p>

            <p>
              Kupac odgovara za umanjenje vrijednosti proizvoda koje je nastalo
              rukovanjem većim od onoga koje je potrebno za utvrđivanje
              prirode, karakteristika i funkcionalnosti proizvoda.
            </p>

            <p>
              Trošak povrata proizvoda kod jednostranog odustanka snosi kupac,
              osim ako je proizvod neispravan, pogrešno isporučen ili važeći
              propisi određuju drugačije.
            </p>
          </section>

          <section>
            <h3>10. Personalizirani proizvodi i dioptrijske naočale</h3>

            <p>
              Pravo na jednostrani odustanak može biti ograničeno za proizvode
              koji su izrađeni prema specifikaciji kupca, jasno personalizirani
              ili izrađeni prema individualnim mjerama ili receptu kupca, kada
              je takav izuzetak dopušten važećim propisima.
            </p>

            <p>
              To se može odnositi na dioptrijska stakla, naočale izrađene prema
              receptu i druge proizvode posebno prilagođene kupcu.
            </p>

            <p>
              Ako se na proizvod primjenjuje takvo ograničenje, kupac će o tome
              biti jasno obaviješten prije potvrđivanja narudžbe.
            </p>

            <p>
              Ova odredba ne ograničava prava kupca ako je personalizirani
              proizvod neispravan, oštećen, pogrešno izrađen ili ne odgovara
              potvrđenoj narudžbi.
            </p>
          </section>

          <section>
            <h3>11. Reklamacije</h3>

            <p>
              Kupac može podnijeti reklamaciju ako je isporučeni proizvod:
            </p>

            <ul>
              <li>oštećen ili neispravan;</li>
              <li>pogrešno isporučen;</li>
              <li>nepotpun;</li>
              <li>
                značajno drugačiji od proizvoda opisanog ili naručenog putem
                webshopa;
              </li>
              <li>
                kod proizvoda izrađenog po narudžbi, nije izrađen prema
                potvrđenim podacima kupca.
              </li>
            </ul>

            <p>
              Reklamacija se može poslati na{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>{" "}
              ili prijaviti putem telefona{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>.
            </p>

            <p>Reklamacija treba sadržavati:</p>

            <ul>
              <li>ime i prezime kupca;</li>
              <li>broj narudžbe;</li>
              <li>opis problema;</li>
              <li>
                fotografije proizvoda ili pakovanja, kada mogu pomoći pri
                utvrđivanju problema;
              </li>
              <li>kontakt podatke kupca.</li>
            </ul>

            <p>
              Trgovac će potvrditi prijem reklamacije i odgovoriti u roku
              propisanom važećim zakonom.
            </p>

            <p>
              Ako je reklamacija opravdana, kupcu će se, zavisno od okolnosti i
              zakonskih prava, ponuditi popravak, zamjena proizvoda, sniženje
              cijene ili zamjena proizvoda.
            </p>

            <p>
              Trošak opravdanog povrata neispravnog ili pogrešno isporučenog
              proizvoda snosi Trgovac.
            </p>
          </section>

          <section>
            <h3>13. Garancija i prava kupca</h3>

            <p>
              Za proizvode koji imaju proizvođačku ili komercijalnu garanciju,
              kupcu će biti dostupni uslovi i trajanje takve garancije.
            </p>

            <p>
              Zakonska prava kupca zbog nedostatka ili nesaobraznosti proizvoda
              postoje nezavisno od eventualne komercijalne garancije i ne mogu
              biti isključena ovim uslovima.
            </p>
          </section>

          <section>
            <h3>14. Otkazivanje narudžbe od strane Trgovca</h3>

            <p>Trgovac može otkazati narudžbu ako:</p>

            <ul>
              <li>naručeni proizvod nije dostupan;</li>
              <li>nije moguće potvrditi plaćanje;</li>
              <li>
                podaci za kontakt ili dostavu nisu potpuni ili očigledno nisu
                tačni;
              </li>
              <li>postoji očigledna tehnička greška u cijeni ili opisu;</li>
              <li>
                postoje opravdane sumnje na prevaru, zloupotrebu ili
                neovlašteno korištenje načina plaćanja;
              </li>
              <li>narudžbu nije moguće izvršiti zbog zakonskih ograničenja.</li>
            </ul>

            <p>
              Ako je otkazana narudžba već plaćena, kupcu će biti vraćen
              naplaćeni iznos putem odgovarajućeg načina plaćanja.
            </p>
          </section>

          <section>
            <h3>15. Odgovornost korisnika</h3>

            <p>Korisniku nije dozvoljeno:</p>

            <ul>
              <li>koristiti webshop protivno važećim propisima;</li>
              <li>dostavljati netačne ili tuđe podatke;</li>
              <li>pokušavati neovlašteno pristupiti webshopu ili serveru;</li>
              <li>ometati rad webshopa;</li>
              <li>unositi zlonamjerni kod ili drugi štetni sadržaj;</li>
              <li>
                koristiti sadržaj webshopa bez odgovarajućeg odobrenja.
              </li>
            </ul>
          </section>

          <section>
            <h3>16. Zaštita ličnih podataka</h3>

            <p>
              Lični podaci kupaca obrađuju se u skladu s Politikom privatnosti
              dostupnom na{" "}
              <a href="/privacypolicy">stranici Politika privatnosti</a>.
            </p>

            <p>
              Trgovac ne pohranjuje puni broj platne kartice, datum isteka
              kartice ili CVV sigurnosni broj.
            </p>
          </section>

          <section>
            <h3>17. Intelektualno vlasništvo</h3>

            <p>
              Tekstovi, fotografije, grafički elementi, naziv, logotip i drugi
              sadržaj webshopa zaštićeni su odgovarajućim pravima.
            </p>

            <p>
              Nije dozvoljeno neovlašteno kopiranje, objavljivanje,
              distribuiranje, mijenjanje ili komercijalno korištenje sadržaja
              webshopa.
            </p>
          </section>

          <section>
            <h3>18. Prigovori i rješavanje sporova</h3>

            <p>
              Kupac može pisani prigovor poslati na:
            </p>

            <p>
              <strong>
                TR ALPHA FOCUS, vl. Selimović Vedad, Srebrenik
              </strong>
              <br />
              Ulica 1. Marta
              <br />
              75350 Srebrenik
              <br />
              Bosna i Hercegovina
              <br />
              E-mail:{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
              <br />
              Telefon:{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>
            </p>

            <p>
              Trgovac i kupac nastojat će eventualni spor riješiti dogovorom.
              Ako spor nije moguće riješiti mirnim putem, primjenjuju se važeći
              propisi Bosne i Hercegovine, uključujući obavezna pravila o
              zaštiti potrošača i sudskoj nadležnosti.
            </p>
          </section>

          <section>
            <h3>19. Izmjene uslova</h3>

            <p>
              Trgovac može povremeno izmijeniti ove uslove zbog promjena u
              poslovanju, uslugama, tehnologiji ili važećim propisima.
            </p>

            <p>
              Na pojedinu narudžbu primjenjuje se verzija uslova koja je bila
              objavljena i koju je kupac prihvatio u trenutku slanja
              narudžbe.
            </p>
          </section>

          <section>
            <h3>20. Kontakt</h3>

            <p>
              Za pitanja o proizvodima, narudžbama, plaćanju, dostavi,
              reklamacijama i povratima možete nas kontaktirati:
            </p>

            <p>
              <strong>
                TR ALPHA FOCUS, vl. Selimović Vedad, Srebrenik
              </strong>
              <br />
              Ulica 1. Marta
              <br />
              75350 Srebrenik
              <br />
              Bosna i Hercegovina
              <br />
              Telefon:{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>
              <br />
              E-mail:{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsandConditions;
